import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import useScrollOnMount from "src/hooks/App/useScrollOnMount";
import ForYouSection from "../shared/section/ForYouSection/ForYouSection";
import s from "./FavoritePage.module.scss";
import FavoritePageHeader from "./favorite-product/FavoritePageHeader";
import FavoriteProducts from "./favoritepage-header/FavoriteProducts";

const FavoritePage = () => {
  const { t } = useTranslation();

  useScrollOnMount(200);

  return (
    <>
      <Helmet>
        <title>Favorite</title>
        <meta
          name="description"
          content="Save and manage your favorite products on Exclusive. Create a personalized wishlist to easily access and purchase your preferred items anytime."
        />
      </Helmet>

      <div className="container">
        <main className={s.favoritePage} id="favorite-page">
          <section className={s.favoritePageContent}>
            <FavoritePageHeader />

            <FavoriteProducts />
          </section>

          <ForYouSection />
        </main>
      </div>
    </>
  );
};
export default FavoritePage;
